import React from 'react';
import classnames from 'classnames';
import Icon from 'Shared/Icon';
import * as styles from './base.scss';
import shallowEquals from 'Shared/shallow-equals';
import MyMenigoIcon from './../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import { translate } from 'Shared/translate';
import DropDownMenu, { DropDownItem, Apperance } from 'Shared/DropDownMenu';
class DropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentValue: this.props.value,
            showRequiredValidationMessage: false,
            currentText: this.getCurrentText(this.props.options, this.props.value)
        };
    }
    getCurrentText(options, value) {
        return !!options && !!options.find(x => x.value == value) && options.find(x => x.value == value).text || '';
    }
    onFocus(e) {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }
    onInvalid(e) {
        this.setState({
            showRequiredValidationMessage: !!!this.state.currentValue
        });
    }
    componentDidMount() {
        if (!!this.props.setRef) {
            this.props.setRef(this.input);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !shallowEquals(nextProps, this.props, true) || !shallowEquals(nextState, this.state, true);
        if (!shouldUpdate) {
            console.info('Ignoring update to DropDown');
        }
        return shouldUpdate;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                currentValue: nextProps.value,
                currentText: this.getCurrentText(nextProps.options, nextProps.value),
                showRequiredValidationMessage: !!!nextProps.value
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (!!this.input && this.props.hasFocus) {
            this.input.focus();
        }
    }
    onChange(e) {
        const val = e.target.value;
        const text = e.target.textContent;
        this.onChangeValue(val, text);
    }
    onChangeValue(val, text) {
        this.setState({
            currentValue: val,
            showRequiredValidationMessage: !!!val,
            currentText: text
        }, () => {
            this.props.onChange(val);
            this.props.onClose && this.props.onClose();
        });
    }
    shouldShowValitationMessage() {
        return !!this.props.requiredvalidationmessage && !!this.props.required && !!this.state.showRequiredValidationMessage;
    }
    render() {
        return (React.createElement(React.Fragment, null,
            !!this.props.label && React.createElement("label", { className: classnames(styles.inputLabel), htmlFor: this.props.name },
                this.props.label,
                " ",
                !!this.props.required && React.createElement("span", { className: styles.requiredLabel }, "*")),
            React.createElement("div", { className: classnames(styles.base, this.props.className, {
                    [styles.secondary]: this.props.appearance === 'secondary',
                    [styles.tertiary]: this.props.appearance === 'tertiary',
                    [styles.light]: this.props.appearance === 'light',
                    [styles.big]: this.props.appearance === 'big',
                    [styles.disabled]: !!this.props.disabled,
                    [styles.invalid]: !!this.shouldShowValitationMessage(),
                }) },
                React.createElement("select", { ref: e => (this.input = e), name: this.props.name, onChange: e => this.onChange(e), onFocus: e => this.onFocus(e), onInvalid: e => this.onInvalid(e), value: !!this.props.hardValue ? this.props.value : this.state.currentValue, disabled: this.props.disabled, required: !!this.props.required, style: { opacity: 0, height: 0, width: 0, position: 'absolute' } }, this.props.options.map((o, i) => (React.createElement("option", { key: o.value + "-" + i, title: o.tooltip, disabled: o.disabled, value: o.value }, o.text)))),
                React.createElement(DropDownMenu, { title: this.state.currentText, isInvalid: this.shouldShowValitationMessage(), onClose: () => this.props.onClose && this.props.onClose(), onOpen: () => this.props.onOpen && this.props.onOpen(), childCount: this.props.childCount, disabled: this.props.disabled, appearance: this.props.appearance == "small" ? Apperance.Small : this.props.appearance == "big" ? Apperance.Big : Apperance.Normal }, this.props.options.filter(o => !!o.text).filter(o => this.props.hideDisabledOptions ? (!o.disabled && o.value != this.state.currentValue) : true).map((o, i) => (React.createElement(DropDownItem, { key: "ddi-" + o.value + "-" + i, value: o.value, text: o.text, disabled: o.disabled, onClick: () => { this.onChangeValue(o.value, o.text); } }))))),
            this.shouldShowValitationMessage() && React.createElement("span", { className: styles.requiredField },
                React.createElement(MyMenigoIcon, { name: "alert" }),
                this.props.requiredvalidationmessage)));
    }
}
export class FadeDropDown extends DropDown {
    constructor(props) {
        super(props);
        this.optionRefs = {};
        this.inputId = () => {
            return "dropdown-" + this.props.options.map(o => o.text.charCodeAt(1)).join("-");
        };
        this.handleClickOutside = (event) => {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.setState({ isOpen: false });
            }
        };
        this.selectedIndex = () => {
            const selectedIndex = this.props.options.findIndex(o => o.value === this.state.currentValue);
            return selectedIndex > -1 ? selectedIndex : 0;
        };
        this.openDropdown = () => {
            if (this.props.disabled) {
                return;
            }
            const focusedIndex = this.selectedIndex();
            this.setState({ isOpen: true, focusedIndex }, () => {
                this.optionRefs[focusedIndex] && this.optionRefs[focusedIndex].focus();
            });
        };
        this.closeDropdown = (focusTrigger = false) => {
            this.setState({ isOpen: false }, () => {
                focusTrigger && this.triggerRef && this.triggerRef.focus();
            });
        };
        this.focusOption = (direction) => {
            if (!this.props.options.length) {
                return;
            }
            const focusedIndex = (this.state.focusedIndex + direction + this.props.options.length) % this.props.options.length;
            this.setState({ focusedIndex }, () => this.optionRefs[focusedIndex].focus());
        };
        this.handleTriggerKeyDown = (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.state.isOpen ? this.closeDropdown() : this.openDropdown();
            }
            else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                this.openDropdown();
            }
        };
        this.handleOptionKeyDown = (event, option) => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                this.focusOption(event.key === 'ArrowDown' ? 1 : -1);
            }
            else if ((event.key === 'Enter' || event.key === ' ') && !option.disabled) {
                event.preventDefault();
                this.onSortChange(option.value);
            }
            else if (event.key === 'Escape') {
                event.preventDefault();
                this.closeDropdown(true);
            }
            else if (event.key === 'Tab') {
                this.closeDropdown();
            }
        };
        this.handleBlur = (event) => {
            if (!event.currentTarget.contains(event.relatedTarget)) {
                this.closeDropdown();
            }
        };
        this.state = {
            currentValue: this.props.value,
            showRequiredValidationMessage: false,
            currentText: '',
            isOpen: false,
            focusedIndex: -1
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    onSortChange(val) {
        this.setState({
            currentValue: val,
            isOpen: false,
        }, () => {
            this.props.onChange(val);
            this.triggerRef && this.triggerRef.focus();
        });
    }
    render() {
        const showNewLabel = ["carbon_footprint"];
        const listId = this.inputId() + "-listbox";
        const selectedOption = this.props.options.find(o => o.value === this.state.currentValue);
        const sortProductsLabel = this.props.sortButtonAriaLabel || translate("/ProductListing/SortProducts");
        const selectedLabel = translate("/ProductListing/Selected");
        const disabledLabel = translate("/ProductListing/Disabled");
        return (React.createElement("div", { ref: e => (this.wrapperRef = e), className: classnames(styles.base, styles.fadeDropDown, this.props.className), "data-open": this.state.isOpen, onBlur: this.handleBlur },
            React.createElement("div", { id: listId, className: styles.sortList, role: "listbox", "aria-hidden": !this.state.isOpen }, this.props.options.map((o, index) => {
                const isSelected = o.value === this.state.currentValue;
                return (React.createElement("div", { id: listId + "-option-" + index, key: o.value, ref: element => (this.optionRefs[index] = element), role: "option", "aria-selected": isSelected, "aria-disabled": !!o.disabled, "aria-label": [o.text, o.subText, isSelected && selectedLabel, o.disabled && disabledLabel].filter(Boolean).join(', '), tabIndex: this.state.isOpen && this.state.focusedIndex === index ? 0 : -1, className: styles.sortOptionButton, onClick: () => !o.disabled && this.onSortChange(o.value), onKeyDown: event => this.handleOptionKeyDown(event, o) },
                    isSelected && (React.createElement("span", { className: styles.selectedSortOptionCheck, "aria-hidden": "true" },
                        React.createElement(Icon, { name: "check" }))),
                    o.subText ? (React.createElement(React.Fragment, null,
                        React.createElement("span", null, o.text),
                        React.createElement("span", null, o.subText))) : o.text,
                    showNewLabel.indexOf(o.value) > -1 && (React.createElement("div", { className: styles.label }, translate("/Shared/SortOptions/NewOptionMarking")))));
            })),
            React.createElement("div", { ref: element => (this.triggerRef = element), className: styles.selectedValue, role: "combobox", tabIndex: this.props.disabled ? -1 : 0, "aria-controls": listId, "aria-expanded": !!this.state.isOpen, "aria-label": selectedOption ? `${sortProductsLabel}, ${selectedOption.text}, ${selectedLabel}` : sortProductsLabel, "aria-haspopup": "listbox", "aria-disabled": !!this.props.disabled, onClick: () => this.state.isOpen ? this.closeDropdown() : this.openDropdown(), onKeyDown: this.handleTriggerKeyDown }, !!selectedOption && selectedOption.text),
            React.createElement("span", null,
                React.createElement(MyMenigoIcon, { name: "sort" }))));
    }
}
export default DropDown;
